"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.patchStore = patchStore;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/object/assign"));

var _observable = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/symbol/observable"));

/**
 * Updated redux `Observer` type. This should match the Store type in updated
 * versions of the Redux library. Provided for compatibility with updated the
 * react-redux library.
 */

/**
 * Updated redux `Observable` type. This should match the Store type in updated
 * versions of the Redux library. Provided for compatibility with updated the
 * react-redux library.
 */

/**
 * Updated redux `Action` type. This should match the Store type in updated
 * versions of the Redux library. Provided for compatibility with updated the
 * react-redux library.
 */

/**
 * Updated redux `Dispatch` type. This should match the Store type in updated
 * versions of the Redux library. Provided for compatibility with updated the
 * react-redux library.
 */

/**
 * Updated redux `Reducer` type. This should match the Store type in updated
 * versions of the Redux library. Provided for compatibility with updated the
 * react-redux library.
 */

/**
 * Updated redux `Store` type. This should match the Store type in updated
 * versions of the Redux library. Provided for compatibility with updated the
 * react-redux library.
 */

/**
 * Add observability to a legacy Redux store. This is required for a legacy
 * store to work with an updated version of the react-redux library.
 */
function patchStore(store) {
  if (store[_observable.default] != null) {
    return store;
  }

  var patchedStore = (0, _assign.default)(store, (0, _defineProperty2.default)({}, _observable.default, function () {
    return {
      subscribe: function subscribe(observer) {
        var unsubscribe = store.subscribe(function () {
          var _observer$next;

          return (_observer$next = observer.next) === null || _observer$next === void 0 ? void 0 : _observer$next.call(observer, store.getState());
        });
        return {
          unsubscribe: unsubscribe
        };
      }
    };
  }));
  return patchedStore;
}